<template>
<div class="ma-0">
    <div class="my-2" style="font-size: 25px; font-weight: bold">
        후원 방법
    </div>
    <div class="primary-divider mt-2" />
    <div class="my-8">
        <div class="pb-3" style="font-size: 20px; font-weight: bold">계좌이체</div>
        <div>국민 994402-01-230019 이*호</div>
    </div>

    <div class="my-8">
        <div v-if="$store.state.mobile">
            <a style="font-size: 20px; font-weight: bold; text-decoration: underline" @click="mobileSponsor">카카오페이로 간편후원</a>
        </div>
        <div v-else>
            <div class="pb-3" style="font-size: 20px; font-weight: bold" @click="mobileSponsor">카카오페이</div>
            <div>1. 카카오톡앱 열기</div>
            <v-row class="pa-0 ma-0">2. 더보기탭<img width="30" :src="require('@/assets/more.jpg')"/> 클릭</v-row>
            <v-row class="pa-0 ma-0">3. 상단에 스캔<img width="30" :src="require('@/assets/scan.jpg')"/> 클릭</v-row>
            <div>4. 아래 코드를 스캔</div>
            <img class="mt-3" :src="require('@/assets/kakao.png')" />
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'sponsor-view',
    components: {
    },
    data() {
        return {

        }
    },
    computed: {
    },
    created() {},
    async mounted() {},
    methods: {
        mobileSponsor() {
            window.open('https://qr.kakaopay.com/2810060111039909710072079c402115')
        }
    }
}
</script>
